export default __webpack_public_path__ + "static/banner-img1-1dfbcba444c6cf72dde21f5ba3b7a690.png";